<template>
  <div class="py-4 px-4 mt-5">
    <div class="row">
      <div class="col-4">
        <h4>{{ $t("message.education.choose_category") }}</h4>
        <div>
          <button
            class="btn"
            :class="example == 'ca' ? 'btn-primary' : 'btn-link'"
            @click="setExample('ca')"
          >
            {{ $t("message.menu.comply_advantage") }}
          </button>
        </div>
        <div>
          <button
            class="btn"
            :class="example == '410' ? 'btn-primary' : 'btn-link'"
            @click="setExample('410')"
          >
            {{ $t("message.menu.find_partner_410") }}
          </button>
        </div>
        <div>
          <button
            class="btn"
            :class="example == '886' ? 'btn-primary' : 'btn-link'"
            @click="setExample('886')"
          >
            {{ $t("message.menu.find_partner") }}
          </button>
        </div>
        <div>
          <button
            class="btn"
            :class="example == 'note' ? 'btn-primary' : 'btn-link'"
            @click="setExample('note')"
          >
            {{ $t("message.menu.business_note") }}
          </button>
        </div>
      </div>
      <div class="col-8">
        <iframe
          style="width: 100%; height: 100%; border: 0; min-height: 500px"
          v-if="example !== ''"
          :src="examples[example]"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EducationExamples",
  mounted() {
    setTimeout(() => {
      if (this.$route.params.hash && this.$route.params.hash !== "") {
        this.setExample(this.$route.params.hash);
      }
    }, 400);
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.setExample(this.$route.params.hash);
      },
    },
  },
  data() {
    return {
      example: "",
      examples: {
        ca: "ca.pdf",
        410: "410.pdf",
        886: "886.pdf",
        note: "note.pdf",
      },
    };
  },
  methods: {
    setExample(param) {
      this.example = param;
    },
  },
};
</script>
